import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../common-component/loader/loader.component';
import { ToastrService } from 'ngx-toastr';
import { RitwikiService } from '../../services/raintree/Transmission/ritwiki.service';

@Component({
  selector: 'app-ritwiki-right-slider',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './ritwiki-right-slider.component.html',
  styleUrl: './ritwiki-right-slider.component.scss'
})
export class RitwikiRightSliderComponent implements OnInit, OnChanges {
  @Input() isVisible: boolean = false;
  @Output() closed = new EventEmitter<void>;
  isLoading: boolean = false;
  pageNo: number = 1;
  paginationArray: number = 0;
  dontLoadDuplicacy: boolean = false;

  prevReqArr: any[] = [];

  constructor(
    private _apiService: RitwikiService,
    private toaster: ToastrService
  ) { }

  ngOnInit(): void {
    // console.log('working?');
    // console.log(this.isVisible);
    // this.fetchRitwikiPrevReqsAPI();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isVisible'] && changes['isVisible'].currentValue === false) {
      this.dontLoadDuplicacy = false;
      this.pageNo = 1;
      this.fetchRitwikiPrevReqsAPI();
    }
  }

  onCross() {
    // console.log(this.isVisible);
    this.closed.emit();
  }

  fetchRitwikiPrevReqsAPI() {
    this.isLoading = true;
    this._apiService.fetchRitwikiPrevReqsAPI({ pageNo: this.pageNo, pageSize: 7 }).subscribe({
      next: (response) => {
        // console.log('Success---->', response.data);
        if (this.dontLoadDuplicacy) {
          this.prevReqArr = [...response.data, ...this.prevReqArr];
        } else {
          this.prevReqArr = response.data;
        }
        this.paginationArray = response.data.length;
        // console.log('1st api call', this.paginationArray);
        this.isLoading = false;
      }, error: (err) => {
        // console.log('Error----->', err);
        this.isLoading = false;
      }
    });
  }

  loadMoreData() {
    // console.log(this.paginationArray, 'kitna data ?');
    if (this.paginationArray < 7) {
      this.toaster.error('No more date to display');
      return;
    } else {
      this.dontLoadDuplicacy = true;
      // console.log(this.dontLoadDuplicacy);
      this.pageNo++;
      this.fetchRitwikiPrevReqsAPI();
    }
  }


}
